import { fonts, palette } from "@kashmere/core";
import { productColors } from "./colors.js";

const subNames = {
  aten:  "Atén",
  pulse: "Pulse",
  silk:  "Silk",
  esqe:  "Esqe",
};

const sizeMap = {
  sm: { kashmere: 18, sub: 16 },
  md: { kashmere: 24, sub: 22 },
  lg: { kashmere: 32, sub: 28 },
};

// #291 — the header lockup: KASHMERE in Cormorant Garamond 600, letter-spaced,
// lit gold; the product name beneath in Cormorant italic, product accent.
// `darkKashmere` is accepted for callers but has no meaning on a dark-first surface.
export function ProductLockup({ product = "aten", size = "md" }) {
  const { kashmere: kashmereSize, sub: subSize } = sizeMap[size] || sizeMap.md;
  const accentColor = productColors[product] || productColors.aten;
  const subName = subNames[product] || product;

  return (
    <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
      <span
        style={{
          fontFamily: fonts.serif,
          fontWeight: 600,
          fontSize: kashmereSize,
          color: palette.gold.bright,
          letterSpacing: "3px",
        }}
      >
        Kashmere
      </span>
      <span
        style={{
          fontFamily: fonts.serif,
          fontWeight: 400,
          fontStyle: "italic",
          fontSize: subSize,
          color: accentColor,
        }}
      >
        {subName}
      </span>
    </div>
  );
}
